<header
  class="header"
  [class.scrolled]="isScrolled"
  [class.dark-bg]="isDarkBackground"
  [class.light-bg]="!isDarkBackground"
  [class.mobile-menu-open]="isMobileMenuOpen"
>
  <div class="header--container">
    <!-- Logo -->
    <div class="header--logo">
      <a routerLink="/" class="logo--link">
        <img
          src="/header/tanuh-logo.png"
          alt="TANUH"
          class="logo--image logo--image-tanuh"
          width="60"
          height="60"
        />
        <span class="logo--divider" aria-hidden="true"></span>
        <img
          src="/header/moe-logo.png"
          alt="Ministry of Education, Government of India"
          class="logo--image logo--image-moe"
          width="71"
          height="33"
        />
        <span class="logo--divider" aria-hidden="true"></span>
        <img
          src="/header/nha-logo.png"
          alt="National Health Authority"
          class="logo--image logo--image-nha"
          width="74"
          height="32"
        />
      </a>
    </div>

    <!-- Navigation Menu -->
    <nav class="header--nav">
      <ul class="nav--menu">
        <li class="nav--item">
          <a routerLink="/reference"
             class="nav--link"
             [class.nav--link-active]="isReferenceDatasetsPageActive()"
             (click)="closeMobileMenu()"
            >Benchmarking Datasets</a
          >
        </li>
        <li class="nav--item">
          <a routerLink="/leadership"
             class="nav--link"
             [class.nav--link-active]="isLeadershipPageActive()"
             (click)="closeMobileMenu()"
            >Leaderboard</a
          >
        </li>
        <li class="nav--item">
          <a [href]="contactUsComposeUrl"
             class="nav--link"
             target="_blank"
             rel="noopener noreferrer"
             (click)="closeMobileMenu()"
            >Contact Us</a
          >
        </li>
      </ul>
    </nav>

    <!-- Action Buttons -->
    <div class="header--actions">
      <button
        class="header--accessibility-btn"
        (click)="toggleAccessibilityPanel()"
        aria-label="Accessibility"
        [attr.aria-expanded]="isAccessibilityPanelOpen"
        type="button"
      >
        <img
          src="/assets/images/landing/icon-accessibility.png"
          alt=""
          width="24"
          height="24"
          aria-hidden="true"
        />
        <span class="header--accessibility-text">Accessibility</span>
      </button>

      <!-- Show Login/Register buttons when NOT logged in -->
      <ng-container *ngIf="!isLoggedIn">
        <button class="btn--login" (click)="onLogin()" type="button">Log in</button>
        <button class="btn--register" (click)="onRegister()">
          Register
        </button>
      </ng-container>

      <!-- Show User dropdown when logged in -->
      <ng-container *ngIf="isLoggedIn">
        <div class="user--dropdown-container">
          <button 
            class="user--dropdown-trigger" 
            (click)="toggleUserDropdown($event)"
            [class.active]="isUserDropdownOpen"
          >
            <span class="user--avatar">{{ userInitials }}</span>
          </button>

          <!-- Dropdown Menu -->
          <div class="user--dropdown-menu" *ngIf="isUserDropdownOpen" (click)="$event.stopPropagation()">
            <ul class="dropdown--list">
              <li class="dropdown--item" *ngIf="false">
                <button
                  class="dropdown--link"
                  [class.disabled]="isUpgradeDisabled"
                  [disabled]="isUpgradeDisabled"
                  (click)="onUpgradeRoleClick($event)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Upgrade Your Role
                </button>
              </li>
              <li class="dropdown--item">
                <button class="dropdown--link" (click)="navigateToDashboard(); closeUserDropdown()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Dashboard
                </button>
              </li>
              <li class="dropdown--item">
                <button class="dropdown--link" (click)="navigateToProfile()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Profile
                </button>
              </li>
            </ul>
            <div class="dropdown--divider"></div>
            <button class="dropdown--logout" (click)="onLogout()">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Sign Out
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Hamburger Menu Button (Mobile Only) -->
      <button
        class="btn--hamburger"
        (click)="toggleMobileMenu()"
        aria-label="Toggle menu"
      >
        <span class="hamburger--icon">
          <span class="hamburger--line"></span>
          <span class="hamburger--line"></span>
          <span class="hamburger--line"></span>
        </span>
      </button>
    </div>
  </div>

  <!-- Mobile Menu Overlay -->
  <div
    class="mobile-menu--overlay"
    (click)="closeMobileMenu()"
    *ngIf="isMobileMenuOpen"
  ></div>

  <!-- Mobile Menu -->
  <nav class="mobile-menu" [class.open]="isMobileMenuOpen">
    <ul class="mobile-menu--list">
      <li class="mobile-menu--item">
        <a routerLink="/reference"
           class="mobile-menu--link"
           [class.mobile-menu--link-active]="isReferenceDatasetsPageActive()"
           (click)="closeMobileMenu()"
          >Benchmarking Datasets</a
        >
      </li>
      <li class="mobile-menu--item">
        <a routerLink="/leadership"
           class="mobile-menu--link"
           [class.mobile-menu--link-active]="isLeadershipPageActive()"
           (click)="closeMobileMenu()"
          >Leaderboard</a
        >
      </li>
      <li class="mobile-menu--item">
        <a [href]="contactUsComposeUrl"
           class="mobile-menu--link"
           target="_blank"
           rel="noopener noreferrer"
           (click)="closeMobileMenu()"
          >Contact Us</a
        >
      </li>
      <li class="mobile-menu--item mobile-menu--actions">
        <!-- Show Login/Register in mobile when NOT logged in -->
        <ng-container *ngIf="!isLoggedIn">
          <button class="btn--login-mobile" (click)="onLogin(); closeMobileMenu()">Login</button>
          <button class="btn--register-mobile" (click)="onRegister(); closeMobileMenu()">Register</button>
        </ng-container>

        <!-- Show Logout in mobile when logged in -->
        <ng-container *ngIf="isLoggedIn">
          <button class="btn--logout-mobile" (click)="onLogout(); closeMobileMenu()">Logout</button>
        </ng-container>
      </li>
    </ul>
  </nav>
  
  <!-- Accessibility Panel -->
  <app-accessibility-panel 
    [isOpen]="isAccessibilityPanelOpen"
    (closePanel)="closeAccessibilityPanel()">
  </app-accessibility-panel>

  <!-- Upgrade Role Modal -->
  <app-modal
    [(visible)]="isUpgradeModalVisible"
    header="Upgrade Your Role"
    [width]="'1000px'"
    [showFooter]="false"
  >
    <div class="upgrade-modal-content" style="overflow: visible;">
      <!-- Intro Text -->
      <p class="roles-intro-text">
        Choose a role that aligns with how you want to use TANUH. 
        Each role unlocks specific capabilities—whether you want to explore, 
        publish assets on TANUH or run AI experiments.
      </p>

      <!-- Roles Grid -->
      <div class="roles-grid">
        <div 
          *ngFor="let role of roles" 
          class="role-card"
          [style.border-top-color]="role.color"
        >
          <!-- Leaf Pattern Decoration -->
          <div class="role-card-leaf-pattern">
            <img src="/assets-leaf.png" alt="" class="role-card-leaf-image" />
          </div>
          
          <div class="role-card-header">
            <div class="role-icon-container" [style.background-color]="role.color + '15'">
              <svg class="role-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [style.color]="role.color">
                <path [attr.d]="role.icon" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="role-title-container">
              <h3 class="role-card-title">{{ role.title }}</h3>
              <span 
                class="role-pending-badge" 
                *ngIf="(role.id === 'provider' && hasPendingProviderRole) || (role.id === 'compute' && hasPendingComputeRole)"
              >
                Request Pending
              </span>
              <span 
                class="role-granted-checkmark" 
                *ngIf="(role.id === 'provider' && hasProviderRole) || (role.id === 'compute' && hasComputeRole)"
                title="Granted"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="checkmark-icon">
                  <path d="M20 6L9 17l-5-5"/>
                </svg>
              </span>
            </div>
          </div>
          
          <p class="role-card-description">{{ role.description }}</p>
          
          <!-- Pending Organisation Note - Only for Data Provider when status is pending -->
          <div class="role-organisation-note role-organisation-note--pending" *ngIf="role.id === 'provider' && showPendingOrganisationNote">
            <svg class="organisation-note-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
            <span class="organisation-note-text">Your request has been sent waiting for <span class="organisation-note-text--approval">approval</span></span>
          </div>
          
          <!-- Granted Organisation Note - Only for Data Provider when status is granted -->
          <div class="role-organisation-note role-organisation-note--granted" *ngIf="role.id === 'provider' && showGrantedOrganisationNote">
            <svg class="organisation-note-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span class="organisation-note-text">Your organisation has been approved</span>
          </div>
          
          <!-- Organisation Requirement Note - Only for Data Provider when user doesn't have organisation -->
          <div class="role-organisation-note" *ngIf="role.id === 'provider' && showOrganisationNote">
            <svg class="organisation-note-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
            <span class="organisation-note-text">You need to be part of an Organisation</span>
          </div>
          
          <div class="role-features">
            <div class="feature-item" *ngFor="let feature of role.features">
              <svg class="feature-icon" viewBox="0 0 20 20" fill="currentColor" [style.color]="role.color">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <span>{{ feature }}</span>
            </div>
          </div>
          
          <!-- Request Upgrade Button for other states -->
          <button 
            *ngIf="(role.id !== 'compute' || !hasComputeRole) && !isRoleRequestSent[role.id]"
            class="btn-request-upgrade"
            [class.role-granted]="(role.id === 'provider' && hasProviderRole)"
            [disabled]="isRoleButtonDisabled(role.id)"
            [style.background-color]="role.color"
            (click)="handleRoleSelection(role.id)"
          >
            {{ getRoleButtonText(role.id) }}
          </button>
        </div>
      </div>
    </div>
  </app-modal>

  <app-login-modal
    *ngIf="showLoginModal"
    [redirectUri]="mySubmissionsLoginRedirectUri"
    (visibleChange)="showLoginModal = $event"
  ></app-login-modal>
</header>
